import { render } from "./ViewBeneficiary.vue?vue&type=template&id=1112d10a"
import script from "./ViewBeneficiary.vue?vue&type=script&lang=js"
export * from "./ViewBeneficiary.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__